BX.addCustomEvent("DevBxWebFormCreated", function(app) {

    app.component('devbx-webform-mode-pages', {
        data() {
            return {
                pageMessages: [],
            };
        },
        computed: {
            webFormItemsBySid() {

                let result = {};

                this.$root.webForm.pages.getAllFormFields().forEach(item => {
                    if (item.config && item.config.systemId)
                        result[item.config.systemId] = item;
                });

                return result;
            },

        },
        methods: {
            beforeEnter(el) {
                this.$root.pageChange = true;

                if (this.$root.beforeTransitionCheckErrors) {
                    this.$root.checkPageErrors(false, false);
                }

                el.style.width = this.$refs.content.clientWidth + 'px';

                let height = this.calcChildNodesHeight(this.$refs.pagesTransition.$el.querySelector('.devbx-webform-page').childNodes);
                this.$refs.pagesTransition.$el.style.minHeight = height+'px';
            },

            calcChildNodesHeight(childNodes)
            {
                let height = 0;

                childNodes.forEach(node => {
                    if (node instanceof Element)
                        height += node.getBoundingClientRect().height;
                });

                return height;
            },

            enter(el) {
                let r1 = this.$el.getBoundingClientRect(),
                    r2 = el.getBoundingClientRect();

                //let setHeight = getComputedStyle(el.closest('.devbx-webform-content')).display === 'flex';
                let setHeight = !this.isPopup;

                if (r1.y < 0) {
                    this.$el.scrollIntoView({behavior: "smooth"});
                }

                let height = this.calcChildNodesHeight(this.$refs.pagesTransition.$el.querySelector('.devbx-webform-page-transition-enter-active').childNodes);
                this.$refs.pagesTransition.$el.style.minHeight = height+'px';

                //el.parentNode.style.overflow = 'hidden';

                /*
                let height = 0;

                this.$refs.pagesTransition.$el.childNodes.forEach(node => {

                    if (node instanceof Element)
                    {
                        height = Math.max(height, this.calcChildNodesHeight(node.childNodes));
                    }
                });

                el.parentNode.style.position = 'relative';
                el.parentNode.style.overflow = 'hidden';
                el.parentNode.style.display = 'block';

                if (!setHeight)
                    el.parentNode.style.height = height + 'px';
                 */
            },

            afterEnter(el) {
                el.style.width = '';

                el.parentNode.removeAttribute('style');

                this.$refs.pagesTransition.$el.childNodes.forEach(node => {
                    if (node instanceof Element) {
                        node.removeAttribute('style');
                    }
                });


                this.$root.pageChange = false;

                if (this.$root.beforeTransitionCheckErrors) {
                    this.$root.beforeTransitionCheckErrors = false;

                    this.$root.checkPageErrors(true, true);
                } else {

                    this.$root.activePageWebFormItems.every(item => {
                        if (item.component)
                        {
                            if (typeof item.component.setFocus === 'function') {
                                item.component.setFocus();
                                return false;
                            }
                        }

                        return true;
                    });
                }
            },

            submitForm(action) {
                if (this.$root.submitAjax)
                    return;

                if (this.$root.checkPageErrors(true, true))
                    return;

                if (this.$root.showPageBusyMessages())
                    return;

                let tree = this.$root.getObjectFieldTree('', this.$root.formFields);

                let webFormData = {};

                Object.keys(tree).forEach(fieldName => {
                    let field = tree[fieldName],
                        value = field.value;

                    if (field.type === 'files')
                    {
                        let newValue = [];

                        value.forEach(fileInfo => {
                            newValue.push(fileInfo.fileId);
                        });

                        value = newValue;
                    }

                    webFormData[fieldName] = value;
                });

                this.$root.submitAjax = true;

                BX.ajax.runAction('devbx:forms.api.webform.submitForm', {
                    data: {
                        lang: BX.message('LANGUAGE_ID'),
                        sid: this.$root.sid,
                        fields: JSON.stringify(webFormData),
                    }
                }).then(
                    BX.delegate(this.submitFormSuccess, this),
                    BX.delegate(this.submitFormError, this),
                );
            },

            submitFormSuccess(response)
            {
                this.$root.submitAjax = false;
                this.$root.mode = 'finish-page';
            },

            submitFormError(response)
            {
                this.$root.submitAjax = false;

                let firstErrItem = false;

                response.errors.forEach(error => {

                    if (error.customData && error.customData.fieldId)
                    {
                        let obField = this.webFormItemsBySid[error.customData.fieldId];

                        if (obField)
                        {
                            if (!firstErrItem)
                                firstErrItem = obField;

                            obField.errorMessage = error.message ? error.message : 'Unknown error';
                            return;
                        }
                    }

                    this.$root.errors.push(error);
                });

                if (firstErrItem)
                {
                    if (firstErrItem.rootPage)
                    {
                        let pageNum = Object.values(this.$root.pages).indexOf(firstErrItem.rootPage);

                        if (pageNum>=0)
                        {
                            this.$root.setPageNumber(pageNum);
                        } else {
                            //TODO ошибка на скрытой странице
                        }

                    } else {
                        //TODO не удалось найти страницу элемента
                    }

                } else {
                    if (!this.$root.errors.length)
                    {
                        //TODO заменить на сообщений о неизвестной ошибке
                        this.$root.errors.push('UNKNOWN ERROR');
                    }
                }
            },
        },
        template: `
        <form class="devbx-webform-theme devbx-webform"
            :class="$root.formClass" 
            @submit.stop.prevent>
            <div class="devbx-webform-container">
                <div ref="content" class="devbx-webform-content">
                    <devbx-webform-header :form-settings="$root.webForm.settings" :pages="$root.pages" :active-page="$root.activePage"></devbx-webform-header>
                    <div class="devbx-webform-body">
                    <transition-group name="devbx-webform-page-transition" tag="div" 
                        class="devbx-webform-pages-container"
                        :class="{'devbx-webform-pages-transition': $root.pageChange}"
                        ref="pagesTransition"
                          @before-enter="beforeEnter"
                          @enter="enter"
                          @after-enter="afterEnter"
                    >
                        <devbx-webform-page
                            v-for="page in $root.visiblePages" 
                            :key="page.id"
                            :page="page" 
                            :is-active="$root.activePageId == page.id"
                            :disable-actions="$root.submitAjax"
                            @submit-form="submitForm()"
                            >
                        </devbx-webform-page>
                    </transition-group>
                    </div>
                </div>
            </div>
        </form>
        `
    });
});